export default "__VITE_ASSET__BfIcrKLl__"